import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Configuration from '../components/Configuration';

const SettingsPage = ({ onConfigSave, webhookUrl }) => {
  const [testResult, setTestResult] = useState('');
  const [saveSuccess, setSaveSuccess] = useState(false);
  const navigate = useNavigate();

  const handleConfigSave = (url) => {
    onConfigSave(url);
    setSaveSuccess(true);
    // Show success message briefly before redirecting
    setTimeout(() => {
      navigate('/');
    }, 1500);
  };

  const handleCancel = () => {
    navigate('/');
  };

  const handleTestConnection = async () => {
    if (!webhookUrl) {
      setTestResult('✗ Please save your configuration first.');
      setTimeout(() => setTestResult(''), 5000);
      return;
    }

    setTestResult('Testing connection...');
    
    try {
      const testJobPosting = 'Software Engineer - Test Company\nLooking for a skilled developer with JavaScript and React experience.';
      
      const response = await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          chatInput: testJobPosting
        })
      });

      if (response.ok) {
        setTestResult('✓ Connection successful! Your webhook is working correctly.');
      } else {
        setTestResult('✗ Connection failed. Server returned an error.');
      }
      setTimeout(() => setTestResult(''), 5000);
    } catch (err) {
      setTestResult('✗ Connection failed. Please check your webhook URL.');
      setTimeout(() => setTestResult(''), 5000);
    }
  };

  return (
    <div className="settings-page">
      <div className="settings-header">
        <div className="settings-header-left">
          <button 
            className="home-button"
            onClick={handleCancel}
            title="Go to home"
          >
            Home
          </button>
          <h1>Settings</h1>
        </div>
        {webhookUrl && (
          <button 
            className="test-connection-button"
            onClick={handleTestConnection}
            title="Test your N8N webhook connection"
          >
            Test Connection
          </button>
        )}
      </div>

      <div className="settings-content">
        {saveSuccess && (
          <div className="success-message">
            <p>✓ Configuration saved successfully! Redirecting to home...</p>
          </div>
        )}
        
        {testResult && (
          <div className={testResult.includes('✓') ? 'success-message' : 'error-message'}>
            <p>{testResult}</p>
          </div>
        )}

        <Configuration 
          onConfigSave={handleConfigSave}
          forceEdit={true}
          onCancel={handleCancel}
        />
      </div>
    </div>
  );
};

export default SettingsPage;
